<template>
  <button @click="jumpRemove({ id: jumpId, index })" class="kp-btn-action-sm kp-btn__danger"><i class="fa fa-minus"></i></button>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: [
    'index',
    'jumpId',
  ],
  methods: mapActions([
    'jumpRemove',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** Remove.vue?030eda62
 **/